import React, { Component } from 'react';
import PropTypes from 'prop-types';

import './RemoveItem.scss';
import { observer } from 'mobx-react';

@observer
export default class RemoveItem extends Component {
	static propTypes = {
		remove: PropTypes.func.isRequired,
		index: PropTypes.number.isRequired,
		item: PropTypes.object.isRequired,
		requieresText: PropTypes.bool,
	};

	static defaultProps = {
		requieresText: true,
	};

	removeItem() {
		this.props.remove(this.props.index, this.props.item);
	}

	render() {
		return (
			<div className="RemoveItem" onClick={this.removeItem.bind(this)}>
				<span className="RemoveItem-icon" />
				{this.props.requieresText && 'Remove'}
			</div>
		);
	}
}



// WEBPACK FOOTER //
// ./src/ui/components/RemoveItem/index.js